"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveCell = exports.ActiveSample = exports.ActiveGroup = exports.ActiveElement = void 0;
function addPathSample(path, sample, color) {
    path.unshift({
        type: 'sample',
        name: sample.code,
        color,
    });
}
function addPathGroups(path, group) {
    if (!group)
        return;
    if (group.level === 0)
        return;
    path.unshift({
        type: group.level === 2 ? 'subgroup' : 'group',
        name: group.name,
        color: group.color,
    });
    if (!group.parent)
        return;
    group = group.parent;
    if (group.level === 0)
        return;
    path.unshift({
        type: 'group',
        name: group.name,
        color: group.color,
    });
}
function addPathCell(path, name, color) {
    path.unshift({
        type: 'cell',
        name: name,
        color,
    });
}
class ActiveElement {
    constructor(type = '') {
        this.type = type;
    }
    get name() {
        return 'Unnamed';
    }
    get color() {
        return '#333333';
    }
    getPath() {
        return null;
    }
}
exports.ActiveElement = ActiveElement;
class ActiveGroup extends ActiveElement {
    constructor(group) {
        super();
        this.group = group;
        if (this.group.level === 1) {
            this.type = 'group';
        }
        else {
            this.type = 'subgroup';
        }
    }
    get name() {
        return this.group.name;
    }
    get color() {
        return this.group.color;
    }
    getPath() {
        const path = [];
        addPathGroups(path, this.group);
        return path;
    }
}
exports.ActiveGroup = ActiveGroup;
class ActiveSample extends ActiveElement {
    constructor(sample, parent) {
        super('sample');
        this.sample = sample;
        this.parent = parent;
    }
    get name() {
        return this.sample.code;
    }
    get color() {
        return this.parent.color;
    }
    getPath() {
        const path = [];
        addPathSample(path, this.sample, this.color);
        addPathGroups(path, this.parent);
        return path;
    }
}
exports.ActiveSample = ActiveSample;
class ActiveCell extends ActiveElement {
    constructor(rank_name, rank_value, sample, parent) {
        super('cell');
        this.rank_name = rank_name;
        this.rank_value = rank_value;
        this.sample = sample;
        this.parent = parent;
    }
    get name() {
        return this.rank_name;
    }
    get color() {
        return this.parent.color;
    }
    getPath() {
        const path = [];
        addPathCell(path, this.rank_name, this.color);
        addPathSample(path, this.sample, this.color);
        addPathGroups(path, this.parent);
        return path;
    }
}
exports.ActiveCell = ActiveCell;
